class ScrollGallery extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector(".scroll-gallery__container");
    this.prevButton = this.querySelector(".scroll-gallery__nav-btn--prev");
    this.nextButton = this.querySelector(".scroll-gallery__nav-btn--next");
    this.firstCard = this.querySelector(".scroll-gallery__card");

    this.init();
  }

  init() {
    // Initial check for button states
    this.updateButtonStates();

    // Add click event listeners
    this.prevButton.addEventListener("click", () => this.scroll("prev"));
    this.nextButton.addEventListener("click", () => this.scroll("next"));

    // Add scroll event listener
    this.container.addEventListener("scroll", () => {
      this.updateButtonStates();
    });
  }

  scroll(direction) {
    const scrollAmount = this.firstCard.offsetWidth; // Scroll exactly one card width
    const scrollLeft =
      direction === "prev"
        ? this.container.scrollLeft - scrollAmount
        : this.container.scrollLeft + scrollAmount;

    this.container.scrollTo({
      left: scrollLeft,
      behavior: "smooth",
    });
  }

  updateButtonStates() {
    // Check if at start
    if (this.container.scrollLeft <= 0) {
      this.prevButton.classList.add("scroll-gallery__nav-btn--disabled");
    } else {
      this.prevButton.classList.remove("scroll-gallery__nav-btn--disabled");
    }

    // Check if at end
    const maxScroll = this.container.scrollWidth - this.container.clientWidth;
    if (Math.ceil(this.container.scrollLeft) >= maxScroll) {
      this.nextButton.classList.add("scroll-gallery__nav-btn--disabled");
    } else {
      this.nextButton.classList.remove("scroll-gallery__nav-btn--disabled");
    }
  }
}

if (!customElements.get("scroll-gallery")) {
  customElements.define("scroll-gallery", ScrollGallery);
}
